import { getMetaContentMaybe } from "~/common/get-meta-content"

let brand: "chatbcc" | "ramble" | undefined

const getBrand = () =>
  (brand ??= getMetaContentMaybe<string>("brand") === "ramble" ? "ramble" : "chatbcc")

export const isRambleBrand = (): boolean => getBrand() === "ramble"

export const brandAppName = (): string => getMetaContentMaybe<string>("APP_NAME") ?? "ChatBCC"
